<template>
  <section class="sec">
    <div class="sec-inner">
      <div class="story-teaser">
        <div class="st-left">
          <div class="sec-eyebrow">我的故事</div>
          <h2 class="sec-title">从山西到济南，从前台到技术经理</h2>
          <p class="sec-sub">
            十六岁那年靠一颗色子选了济南，兜里揣着两块钱下的火车。
            在酒店前台敲下第一行代码，白天上学晚上值夜班，教了五年计算机，
            现在带着团队做医疗信息化。
          </p>
          <router-link class="ui-btn ui-btn-primary st-btn" to="/story">
            阅读完整故事
          </router-link>
        </div>
        <div class="st-right">
          <img
            src="/imgs/blog/career/fbdd9ffc4fffa0298fabe83722470621.jpg"
            alt="当年的济南站"
            data-zoom
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "StorySection"
};
</script>

<style scoped>
.story-teaser {
  display: flex;
  align-items: center;
  gap: 56px;
}
.st-left {
  flex: 1.2;
}
.st-btn {
  margin-top: 26px;
}
.st-right {
  flex: 1;
}
.st-right img {
  width: 100%;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  cursor: zoom-in;
  display: block;
}
@media (max-width: 900px) {
  .story-teaser {
    flex-direction: column;
    gap: 32px;
  }
  .st-right {
    width: 100%;
  }
}
</style>
